export const extractSearchParams = () => {
  const querystring = window.location.search;
  const searchParams = new URLSearchParams(querystring);
  const searchParamsObject = Object.fromEntries([...searchParams]);
  return searchParamsObject;
};
